import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ResultFinal() {
  return (
    <section className="result_nurs p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="m-auto">
            <h2>
              The <span style={{ color: "#00ADEF" }}>Results</span>
            </h2>
            <p>
              We delivered a fully-functional, UX-focused mobile app for iOS and
              Android with one-touch sign-up and various socializing features.
            </p>
            <div className="banner_btn">
              <Link
                to="https://play.google.com/store/apps/details?id=com.selahtech.app"
                rel="noopener noreferrer"
                target="_blank"
              >
                <StaticImage
                  src="../../../images/case-studies/selah/google-store.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={202}
                  height={76}
                />
              </Link>
              <Link
                to="https://apps.apple.com/us/app/selah/id1617474202"
                rel="noopener noreferrer"
                target="_blank"
              >
                <StaticImage
                  src="../../../images/case-studies/selah/app-store.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={207}
                  height={76}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center my-auto offset-xl-1"
          >
            <StaticImage
              src="../../../images/case-studies/selah/tek_img_06.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={614}
              height={651}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ResultFinal;
